/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VehicleActivity
 */
export interface VehicleActivity {
    /**
     * 
     * @type {number}
     * @memberof VehicleActivity
     */
    monitoredObjectId: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleActivity
     */
    count: number;
}

export function VehicleActivityFromJSON(json: any): VehicleActivity {
    return VehicleActivityFromJSONTyped(json, false);
}

export function VehicleActivityFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleActivity {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'monitoredObjectId': json['monitoredObjectId'],
        'count': json['count'],
    };
}

export function VehicleActivityToJSON(value?: VehicleActivity | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'monitoredObjectId': value.monitoredObjectId,
        'count': value.count,
    };
}


